import React, { useEffect, useState } from 'react'
import { useField } from 'formik'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretSquareDown } from '@fortawesome/free-solid-svg-icons'

import useToggle from '../../../hooks/useToggle'
import CheckboxToggle from '../../utils/CheckboxToggle'
import Label from '../../utils/Label'

dayjs.extend(localeData)

const RequestFormStep2ArrivalDays = () => {
  const [fieldArrivalDays, , { setValue: setFieldArrivalDays }] = useField('arrivalDays')

  const [editArrivalDays, toggleEditArrivalDays] = useToggle(false)
  const [arrivalDays, setArrivalDays] = useState(fieldArrivalDays.value || [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setFieldArrivalDays(arrivalDays), [arrivalDays])

  const toggleArrivalDay = dow => {
    if (arrivalDays.includes(dow)) {
      setArrivalDays(arrivalDays.filter(d => d !== dow))
    } else {
      setArrivalDays(arrivalDays.concat([parseInt(dow)]))
    }
  }

  return (
    <div className="mt-8 mb-8">
      <Label className="cursor-pointer" onClick={toggleEditArrivalDays}>
        Only arrive on specific weekdays:
        <FontAwesomeIcon icon={faCaretSquareDown} className="ml-6" />
      </Label>
      <span className="text-md text-gray-500">(optional)</span>


      {(editArrivalDays || arrivalDays.length > 0) && (
        <div className="shadow-md rounded-lg bg-green-200">
          {dayjs.weekdays().map((day, dow) => (
            <div className="inline-flex flex-1 pl-3 pr-3" key={day}>
              <CheckboxToggle
                key={day}
                label={day}
                checked={(arrivalDays || []).includes(dow)}
                onChange={() => toggleArrivalDay(dow)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default RequestFormStep2ArrivalDays
